import * as queryString from 'query-string';
import React from 'react';
import { Route } from 'react-router';

import Config from 'src/lib/config';

interface RenderProps {
  clickableTabs: typeof Config.metricsTabs;
  visibleTabs: typeof Config.metricsTabs;
  defaultTab: (typeof Config.metricsTabs)[0];
}

const AllowedTabsProvider = ({
  children,
  isDemoPage,
}: {
  children: (renderProps: RenderProps) => React.ReactNode;
  isDemoPage: boolean;
}) => (
  <Route>
    {({ location }) => {
      const search = queryString.parse(location.search);
      const isServiceLevel = !search.query;
      const activeTab = search[Config.queryParameters.ActiveReportPaneTab];

      // all tabs that are not set to isVisibleOnlyWhenActive are visible,
      // but the one's that don't apply to the query are not clickable
      const clickableTabs = Config.metricsTabs
        .filter((tabConfig) =>
          isServiceLevel
            ? tabConfig.isServiceLevel
            : tabConfig.isOperationLevel,
        )
        .filter(
          // If tab is configured as `isVisibleOnlyWhenActive`, then only show
          // it when it's active
          (tabConfig) =>
            tabConfig.isVisibleOnlyWhenActive
              ? activeTab === tabConfig.value
              : true,
        )
        // Filter out tabs restricted by demos
        .filter((allowedTab) =>
          isDemoPage ? allowedTab.isAvailableInDemo : true,
        );

      const visibleTabs = Config.metricsTabs.filter((tabConfig) =>
        tabConfig.isVisibleOnlyWhenActive
          ? activeTab === tabConfig.value
          : true,
      );

      return children({
        clickableTabs,
        visibleTabs,
        // TODO: Remove non null assertion, added when turning on noUncheckedIndexedAccess
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        defaultTab: clickableTabs[0]!,
      });
    }}
  </Route>
);

export { AllowedTabsProvider };
